/**
 * Contains all the data points related to premium domain option
 */
// Set donotsample as true
// The premium is for paied user, we need to know what the user is doing and get enough logs to diagnostic issues
export default {
    DomainDashboardGetStarted: {
        datapoint: {
            name: 'DomainDashboardGetStarted',
            options: { doNotSample: true },
        },
    },
    DomainDashboardManageDomain: {
        datapoint: {
            name: 'DomainDashboardManageDomain',
            options: { doNotSample: true },
        },
    },
    DomainDashboardCreateEmail: {
        datapoint: {
            name: 'DomainDashboardCreateEmail',
            options: { doNotSample: true },
        },
    },
    DomainDashboardRemoveDomain: {
        datapoint: {
            name: 'DomainDashboardRemoveDomain',
            options: { doNotSample: true },
        },
    },
    DomainDashboarDomainStatus: {
        datapoint: {
            name: 'DomainDashboarDomainStatus',
            customData: function (dnsValue, domainName, isDomainValid, isDomainExisted, purchaseType, purchaseDate) { return ({
                dnsValue: dnsValue,
                domainName: domainName,
                isDomainValid: isDomainValid,
                isDomainExisted: isDomainExisted,
                purchaseType: purchaseType,
                purchaseDate: purchaseDate,
            }); },
            options: { doNotSample: true },
        },
    },
    DomainDashboarDomainUIStatus: {
        datapoint: {
            name: 'DomainDashboarDomainUIStatus',
            customData: function (isAliasAdded, uiStatus) { return ({
                isAliasAdded: isAliasAdded,
                uiStatus: uiStatus,
            }); },
            options: { doNotSample: true },
        },
    },
};
//# sourceMappingURL=datapoints.js.map